import React from "react";
import {
  Button,
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Box,
  Spinner,
  Center,
  Text,
} from "@chakra-ui/react";
import { Trans, useTranslation } from "react-i18next";
import { pdfjs, Document, Page } from "react-pdf";
import getConfig from "next/config";
import axios from "axios";
import useSWR from "swr";
import { format } from "date-fns";
import { Virtuoso } from "react-virtuoso";

import useIsMobile from "@/hooks/useIsMobile";
import { mutateSession } from "@/hooks/useUser";
import { useToastPromise } from "@/hooks/useToast";

const { publicRuntimeConfig } = getConfig();

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const TermsModal: React.FC = () => {
  const [numPages, setNumPages] = React.useState(null);
  const [reachedBottom, setReachedBottom] = React.useState(false);
  const { t } = useTranslation("common");
  const toast = useToastPromise();
  const isMobile = useIsMobile();
  const { data: regulation } = useSWR("/app/regulations/current?data=true");

  const onDocumentLoadSuccess = ({ numPages }) => setNumPages(numPages);
  const onAcceptRegulations = React.useCallback(() => {
    toast.promise(
      axios.put("/app/regulations/accept").then(() => mutateSession())
    );
  }, []);

  return (
    <Modal
      isOpen
      isCentered
      motionPreset="slideInBottom"
      onClose={() => {}}
      preserveScrollBarGap
      size={isMobile ? "full" : "2xl"}
    >
      <ModalContent>
        <form noValidate>
          <ModalHeader>
            <Trans i18nKey="accredRegulation">
              <>Regulamin</> serwisu Accred.eu
            </Trans>
          </ModalHeader>
          <ModalBody>
            <Box maxW="100vw" overflowY="scroll" border="1px solid black">
              <Document
                file={`${publicRuntimeConfig.basePath}/legal/regulations`}
                onLoadSuccess={onDocumentLoadSuccess}
                loading={() => (
                  <Center>
                    <Spinner />
                  </Center>
                )}
              >
                <Virtuoso
                  style={{ height: "400px" }}
                  totalCount={numPages}
                  endReached={(_) => setReachedBottom(true)}
                  itemContent={(index) => (
                    <Page
                      key={`page_${index + 1}`}
                      pageNumber={index + 1}
                      renderTextLayer={false}
                      loading=""
                    />
                  )}
                />
              </Document>
            </Box>
          </ModalBody>

          <ModalFooter display="flex" justifyContent="space-between">
            <Text>
              <strong>{t("press.publishDate")}: </strong>
              {regulation?.createdAt &&
                format(new Date(regulation.createdAt), "dd/MM/yyyy H:mm")}
            </Text>
            <Button
              colorScheme="red"
              ml={3}
              disabled={!reachedBottom}
              onClick={onAcceptRegulations}
            >
              {t("accept")}
            </Button>
          </ModalFooter>
        </form>
      </ModalContent>
    </Modal>
  );
};

export default TermsModal;
